var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-facebook-original';
                    var viewUrl = 'gfx/sprite.svg#view-icon-facebook-original';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 1024 1024',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };